import type { FaireProductEntity } from "../../entity_types/product";

export const p_8fdxngyf: FaireProductEntity = {
  token: "p_8fdxngyf",
  type: "product",
  name: "No. 05 Coconut + Vetiver - Shades Collection",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/50c2a0c54cf057952f145f9fe48b9782606a1c09e6ee6e346fed1d2b86548b7e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/250658dd3c41e81a2dc8144a88a65e04d005b5fdc80f908149d029732526a681.png",
    "https://cdn.faire.com/fastly/81ad22774399cfc096403cd2c8a672a089fd5eff3e21f99c454e260115fc6048.jpeg",
  ],
  priceDollars: 18,
  description:
    "dilo. candles are hand poured and made using 100% USA grown Soy Wax. \n\nThe Shades Collection offers a new look to the already beloved dilo scents. Matte glass vessel housed in a heavy stock, foil printed box - providing for a look bold enough to match the candle within. \n\nNo. 05 Coconut + Vetiver is a combination of sweet coconut and earthy vetiver root. This mash-up reveals an unexpected scent that is fresh and bright yet deep and honest. As it burns, you will smell fresh notes of floral, subtle woody notes, and ripened fig.\n\nTop: Buttered Rum, Jasmine\nHeart: Vanilla, Cedarwood, Carnation\nBase: Dried Coconut, Vetiver\n\n10 ounces - Burns 60 Hours\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:05.926Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
